import { useEffect } from 'react';
import { useHistory } from 'react-router';

const BANNER_META_SELECTOR = 'meta[name="apple-itunes-app"]';

/**
 * Points the iOS Smart App Banner at the page the user is on.
 *
 * The banner tag in index.html is built with only the App Store id. Its
 * `app-argument` has to be the current URL, so that Open, when the app is
 * installed, hands the app this page instead of just launching it. The app
 * opens the page when it knows it, and otherwise starts as usual.
 *
 * Does nothing where the tag is absent, which is every environment with no
 * mobile app.
 */
export function updateSmartAppBannerArgument() {
    const meta = document.querySelector<HTMLMetaElement>(BANNER_META_SELECTOR);
    const appId = meta?.content
        .split(',')
        .map((part) => part.trim())
        .find((part) => part.startsWith('app-id='));

    if (meta && appId) {
        meta.content = `${appId}, app-argument=${window.location.href}`;
    }
}

/**
 * Keeps the banner current by listening to the router's navigation events.
 *
 * Reads only the router's history object, which never changes, so the
 * component that mounts this is not re-rendered on navigation because of it.
 */
export function useSmartAppBannerArgument() {
    const history = useHistory();

    useEffect(() => {
        updateSmartAppBannerArgument();
        return history.listen(updateSmartAppBannerArgument);
    }, [history]);
}
